import styles from "./styles.module.scss";
import { SearchFilterIcon } from "icons";
import playIconVideo from "icons/video.png";
import { useEffect, useRef, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { OnCollapseIcon } from "pages/m2c-simulation/icons";
import { ConditionalRenderer, CustomDatePicker } from "components";
import { Button, Collapse, Input, Popover, Spin } from "antd";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { ReactComponent as DropdownArrow } from "icons/dropdownArrow.svg";
import moment from "moment";
import { VideoModal } from "components/VideoModal";
import { getEmailAndVideoNameFromUrl } from "utils/helpers";
import { useListVideos } from "hooks/use-list-videos";
import { useDebounce } from "hooks";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";
import { SearchOutlined } from "@ant-design/icons";
import { DatePicker } from "antd";
import { FormItem } from "pages/statistics/filterV1/filterModal";
import dayjs from "dayjs";
import { VideosContainer } from "./videosContainer";

const { RangePicker } = DatePicker;

export const UserHistory = ({
  connectedStrikerId,
  handleNext,
  getClickedVideo,
  goTo,
}) => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState();
  const [fileId, setFileId] = useState();
  const activeKeysFromStorage = sessionStorage.getItem("activeKeys");
  const activeKeysRef = useRef();

  const activeKeys = activeKeysFromStorage
    ? JSON.parse(activeKeysFromStorage)
    : [];
  const [activeKeysArray, setActiveKeysArray] = useState(activeKeys);
  const [videoModalOpen, setVideoModalOpen] = useState({
    playVideoModal: false,
  });

  const [showUrl, setShowUrl] = useState(null);
  const [formValues, setFormValues] = useState({ startDate: "", endDate: "" });
  const [historyDates, setHistoryDates] = useState([]);

  const debounceSearch = useDebounce(search, 700);

  const {
    data: userHistoryDates,
    isLoading: userHistoryDatesLoading,
    refetch: userHistoryDatesRefetch,
  } = UseApiCallForOldDashboardData({
    url: "get_dates",
    method: "POST",
    skip: !connectedStrikerId,
    body: {
      userID: connectedStrikerId,
    },
  });

  useEffect(() => {
    setHistoryDates(userHistoryDates?.dates);
  }, [userHistoryDates]);

  const {
    data: userHistory,
    isLoading: userHistoryLoading,
    refetch: userHistoryRefetch,
  } = UseApiCallForOldDashboardData({
    url: "get_user_history",
    method: "POST",
    skip: !connectedStrikerId,
    body: {
      userID: connectedStrikerId,
    },
  });
  const [
    searchVideos,
    { data: searchVideosData, isLoading: searchVideosLoading },
  ] = UseLazyApiCallOldDashboard({
    url: "search_video",
    method: "POST",
  });

  async function searchVideosHanlder() {
    try {
      await searchVideos({
        params: {
          userID: connectedStrikerId,
          search: debounceSearch,
        },
      });
    } catch (error) {
      console.log({ error });
    }
  }
  useEffect(() => {
    if (debounceSearch) {
      searchVideosHanlder(debounceSearch);
    }
  }, [debounceSearch]);

  const { groupedByDate } = userHistory || {};

  let data = [];

  for (const key in groupedByDate) {
    const localObj = { date: key, videos: groupedByDate[key] };
    data.push(localObj);
  }

  function handleCollapseChange(keys) {
    setActiveKeysArray(keys);
    sessionStorage.setItem("activeKeys", JSON.stringify(keys));
    activeKeysRef.current = [...keys];
  }

  function handleApplyFilter() {
    if (userHistoryDates?.dates) {
      const filtered = userHistoryDates?.dates?.filter(
        (item) =>
          new Date(item) >= new Date(formValues.startDate) &&
          new Date(item) <= new Date(formValues.endDate)
      );
      setHistoryDates(filtered);
    }
  }
  function onClear() {
    setHistoryDates(userHistoryDates?.dates);
    setFormValues({
      startDate: "",
      endDate: "",
    });
  }

  return (
    <Spin spinning={userHistoryLoading}>
      <div style={{ marginTop: "30px" }} className={styles.historyContainer}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>History</h2>

          <div className={styles.filters}>
            <Input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              prefix={<SearchOutlined />}
              style={{ height: "37px", width: "100%" }}
              placeholder="Search here..."
            />
            <Popover
              trigger={"click"}
              content={
                <DatePickers
                  formValues={formValues}
                  setFormValues={setFormValues}
                  handleApplyFilter={handleApplyFilter}
                  onClear={onClear}
                />
              }
              placement="left"
            >
              <div className={styles.filterIcon}>
                <SearchFilterIcon />
              </div>
            </Popover>
          </div>
        </div>
        <ConditionalRenderer condition={!search}>
          <div
            className={styles.listings}
            style={{
              height: "86dvh",
              overflowY: "auto",
            }}
          >
            <Collapse
              expandIconPosition="end"
              bordered={false}
              onChange={handleCollapseChange}
              activeKey={activeKeysRef.current}
              expandIcon={({ isActive }) => (
                <div
                  className={styles.collapseArrow}
                  style={{
                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                >
                  <DropdownArrow />
                </div>
              )}
            >
              {historyDates?.map((item) => (
                <Collapse.Panel
                  key={`collapsed-${item}`}
                  // header={
                  //   <div className={styles.collapseItemHeader}>{data.date}</div>
                  // }
                  header={<DateHeader title={item} />}
                  className={styles.collapseItem}
                >
                  <VideosContainer
                    connectedStrikerId={connectedStrikerId}
                    date={item}
                    userHistory={userHistory}
                    goTo={goTo}
                    getClickedVideo={getClickedVideo}
                    // debounceSearch={debounceSearch}
                  />
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
        </ConditionalRenderer>
        <ConditionalRenderer condition={search}>
          <div
            className={styles.listings}
            style={{
              height: "86dvh",
              overflowY: "auto",
            }}
          >
            <Collapse
              expandIconPosition="end"
              bordered={false}
              onChange={handleCollapseChange}
              activeKey={activeKeysRef.current}
              expandIcon={({ isActive }) => (
                <div
                  className={styles.collapseArrow}
                  style={{
                    transform: isActive ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                >
                  <DropdownArrow />
                </div>
              )}
            >
              {searchVideosData?.map((item) => (
                <Collapse.Panel
                  key={`collapsed-${item?.date}`}
                  // header={
                  //   <div className={styles.collapseItemHeader}>{data.date}</div>
                  // }
                  header={<DateHeader title={item?.date} />}
                  className={styles.collapseItem}
                  // onClick={() => setDate(item?.date)}
                >
                  <Spin spinning={false}>
                    <VideosContainer
                      connectedStrikerId={connectedStrikerId}
                      date={item}
                      userHistory={userHistory}
                      goTo={goTo}
                      getClickedVideo={getClickedVideo}
                      search
                      item={item}
                    />
                  </Spin>
                </Collapse.Panel>
              ))}
            </Collapse>
          </div>
        </ConditionalRenderer>
      </div>
      <VideoModal
        setVideoModalOpen={setVideoModalOpen}
        videoModalOpen={videoModalOpen}
        showUrl={showUrl}
        fileid={fileId}
        setFileId={setFileId}
      />
    </Spin>
  );
};

function DisplayTitle({ title }) {
  return <p className={styles.title}>{title}</p>;
}
// function DisplayTitle({ title }) {
//   const firstTitle = title?.slice(0, 4).toUpperCase() || "";
//   if (firstTitle.includes("M2C")) {
//     const lastTitle = title?.slice(4);
//     const titleArray = [firstTitle, lastTitle];
//     const titleJSX = titleArray?.map((state, idx) => (
//       <p className={styles.title} key={idx}>
//         {state}
//       </p>
//     ));
//     return titleJSX;
//   }

//   return <p className={styles.title}>{title}</p>;
// }
function VideoLabel({ title, bg }) {
  return (
    <p style={{ backgroundColor: bg }} className={styles.videoLabels}>
      {title}
    </p>
  );
}

function DateHeader({ title }) {
  const date = new Date(title);

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const formattedDate = date.toLocaleDateString(undefined, options);

  return <div className={styles.collapseItemHeader}>{formattedDate}</div>;
}

function DatePickers({
  formValues,
  setFormValues,
  handleApplyFilter,
  onClear,
}) {
  function formDataHandler(name, value) {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  return (
    <div>
      <div style={{ display: "flex", gap: "20px" }}>
        <FormItem label="Start Date" className={styles.antDateItem}>
          <CustomDatePicker
            value={formValues.startDate}
            title={"startDate"}
            changeHandler={formDataHandler}
            selectsStart={true}
            startDate={formValues.startDate}
            endDate={formValues.to}
            maxDate={new Date()}
            disabled={false}
          />
        </FormItem>
        <FormItem label="End Date" className={styles.antDateItem}>
          <CustomDatePicker
            value={formValues.endDate}
            title={"endDate"}
            changeHandler={formDataHandler}
            selectsStart={true}
            startDate={formValues.startDate}
            endDate={formValues.endDate}
            minDate={new Date(formValues.startDate)}
            maxDate={new Date()}
            disabled={!formValues.startDate}
          />
        </FormItem>
      </div>
      <div
        style={{
          justifySelf: "end",
          marginTop: "10px",
          display: "flex",
          gap: "10px",
        }}
      >
        <Button
          onClick={handleApplyFilter}
          style={{ backgroundColor: "#006AB3", color: "white" }}
        >
          Apply
        </Button>
        <Button onClick={onClear}>Clear</Button>
      </div>
    </div>
  );
}

// {searchVideosData?.map((item) => (
//         <Collapse.Panel
//           key={`collapsed-${item?.date}`}
//           // header={
//           //   <div className={styles.collapseItemHeader}>{data.date}</div>
//           // }
//           header={<DateHeader title={item?.date} />}
//           className={styles.collapseItem}
//           // onClick={() => setDate(item?.date)}
//         >
//           <Spin spinning={isLoading}>
//             <div
//               className={styles.videoContainer}
//               style={{
//                 "--history-col": gridProperties.noOfColumns,
//                 "--history-row-gap": gridProperties.gridGap,
//               }}
//             >
//               {item?.videos?.map((el, id) => {
//                 const displayTitle = el?.title?.split(".")[0];

//                 const modifiedDisplayTitle = displayTitle?.slice(-6);

//                 return (
//                   <div className={getvideoRowContainerClasses()}>
//                     <div className={styles.cardHeader}>
//                       <div className={styles.cardSubSection}>
//                         <span
//                           className={`${styles.cardImg}`}
//                           onClick={() => thumbnailHandler(el)}
//                         >
//                           <img
//                             src={`${el?.thumbnail}`}
//                             alt="icon-play"
//                             onError={({ currentTarget }) => {
//                               currentTarget.onerror = null;
//                               currentTarget.src = `${playIconVideo}`;
//                             }}
//                           />
//                         </span>
//                       </div>

//                       <div className={styles.iconsContainer}>
//                         <button type="button">
//                           <VisualizeIcon
//                             onClick={() => {
//                               getClickedVideo(el);
//                               goTo(3);
//                             }}
//                           />
//                         </button>
//                         <ConditionalRenderer condition={true}>
//                           <button type="button">
//                             <ReportIcon />
//                           </button>
//                         </ConditionalRenderer>
//                         <button type="button">
//                           <DownloadIcon />
//                         </button>{" "}
//                         <button type="button">
//                           <DeleteIcon />
//                         </button>
//                       </div>
//                     </div>
//                     <div className={styles.displayTitle}>
//                       <ConditionalRenderer condition={el?.title}>
//                         <DisplayTitle
//                           // title={modifiedDisplayTitle}
//                           title={el?.title}
//                         />
//                       </ConditionalRenderer>
//                       <span className={styles.tooltip}>{el?.title}</span>
//                     </div>
//                     <div className={`${styles.cardBody}`}>
//                       <div className={styles.cardFooter}>
//                         <div className={styles.videoDescription}>
//                           <ConditionalRenderer
//                             condition={!el?.isLaunchMonitor}
//                           >
//                             <VideoLabel
//                               // title={"P"}
//                               title={getSwingType(el) ?? "P"}
//                               bg={"#006AB3"}
//                             />
//                             <VideoLabel
//                               // title={"hi"}
//                               title={getVideoLabel(el)}
//                               bg={"#7BB728"}
//                             />
//                             <VideoLabel
//                               title={el?.clubTypeName?.charAt(0) ?? "I"}
//                               // title={"hi"}
//                               bg={"#F4BD00"}
//                             />
//                             <ConditionalRenderer
//                               condition={"hi"}
//                               // condition={getRecordingType(el)}
//                             >
//                               <VideoLabel
//                                 title={"hi"}
//                                 // title={getRecordingType(el)}
//                                 bg={"#326971"}
//                               />
//                             </ConditionalRenderer>
//                             <ConditionalRenderer
//                               condition={el?.forcePlateTypeName}
//                             >
//                               <VideoLabel
//                                 // title={"hi"}
//                                 title={getForcePlateType(el)}
//                                 bg={"#ABA7AF"}
//                               />
//                             </ConditionalRenderer>
//                             <VideoLabel
//                               // title={"hi"}
//                               title={
//                                 el?.isCalibrated
//                                   ? "Calibrated"
//                                   : "Not Calibrated"
//                               }
//                               bg={"#F63E5099"}
//                             />
//                           </ConditionalRenderer>
//                           <ConditionalRenderer
//                             condition={el?.isLaunchMonitor}
//                           >
//                             <VideoLabel
//                               title={getSwingType(el) ?? "P"}
//                               bg={"#006AB3"}
//                             />
//                             <VideoLabel
//                               title={getVideoLabel(el)}
//                               bg={"#7BB728"}
//                             />

//                             <VideoLabel title="LM" bg={"#F4BD00"} />
//                           </ConditionalRenderer>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </Spin>
//         </Collapse.Panel>
//       ))}
